import {
  Card,
  CircularProgress,
  Container,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

import { dataFetch } from "../../utils/data-fetch";
import { useAuth } from "../../context/AuthContext";
import { useEffect, useState } from "react";
import MakeFullScreen from "../MakeFullScreen";
import { useSnackbar } from "src/context/SnackbarContext";

export const BankAccounts = ({ open, handleClose }) => {
  const [accountDetails, setAccountDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const { getAccessToken } = useAuth();
  const { showSnackbar } = useSnackbar();

  const loadData = async () => {
    setLoading(true);

    const url = `/api/extrasales/b2bact/payments/bank-transfer`;

    const ret = await dataFetch(url, await getAccessToken());

    if (ret.success) {
      setAccountDetails(ret.data);
    } else {
      showSnackbar("Load failed!", "error");
    }

    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <MakeFullScreen
      open={open}
      onClose={handleClose}
      fullScreen={true}
      maxWidth={"md"}
      title={"PAYMENT ACCOUNTS"}
    >
      <Container>
        {loading && <CircularProgress />}
        {accountDetails.length > 0 ? (
          accountDetails.map((item, index) => (
            <Card sx={{ my: 2 }}>
              <Stack
                spacing={2}
                direction={"column"}
                sx={{
                  padding: 2,
                  border: "1px solid",
                  borderColor: "grey.300",
                  borderRadius: 2,
                }}
              >
                {/* Bank Name */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Bank Name
                  </Typography>
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {item?.bank_account?.bank || "-"}
                  </Typography>
                </Stack>
                <Divider sx={{ bgcolor: "grey.300" }} />

                {/* Account Name */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Account Name
                  </Typography>
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {item?.bank_account?.acc_name}
                  </Typography>
                </Stack>
                <Divider sx={{ bgcolor: "grey.300" }} />

                {/* Account Number */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  onClick={() => {
                    navigator.clipboard.writeText(item?.bank_account?.acc_no);
                    showSnackbar(`Copied to clipboard`, "success");
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Account Number
                  </Typography>
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {item?.bank_account?.acc_no}
                  </Typography>
                </Stack>
                <Divider sx={{ bgcolor: "grey.300" }} />

                {/* IFSC Code */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  onClick={() => {
                    navigator.clipboard.writeText(item?.bank_account?.ifsc);
                    showSnackbar(`Copied to clipboard`, "success");
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    IFSCode
                  </Typography>
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {item?.bank_account?.ifsc}
                  </Typography>
                </Stack>
                <Divider sx={{ bgcolor: "grey.300" }} />

                {/* Branch */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Branch
                  </Typography>
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {item?.bank_account?.branch || "-"}
                  </Typography>
                </Stack>
                <Divider sx={{ bgcolor: "grey.300" }} />

                {/* UPI ID */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  onClick={() => {
                    navigator.clipboard.writeText(item?.bank_account?.upi);
                    showSnackbar(`Copied to clipboard`, "success");
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    UPI ID
                  </Typography>

                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    {item?.bank_account?.upi || "-"}
                  </Typography>
                </Stack>
              </Stack>
            </Card>
          ))
        ) : (
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            No account details found!
          </Typography>
        )}
      </Container>
    </MakeFullScreen>
  );
};
